<template>
  <div class="kj">
    <div class="nav">
      <img src="/img/logo.png" alt="">
      <div class="left">
        <el-menu
          :default-active="index"
          mode="horizontal"
          class="meun"
          @select="select"
          background-color="#00457d"
          text-color="#fff"
          active-text-color="#fff"
        >
          <el-submenu index="0">
            <template slot="title">
              <i class="el-icon-menu" style="color: #fff"></i>
            </template>
            <el-menu-item index="0">首页</el-menu-item>
            <el-menu-item index="1">邮政制单</el-menu-item>
            <el-menu-item index="2">极速体验版</el-menu-item>
            <el-menu-item index="3">EMS追踪</el-menu-item>
            <el-menu-item index="4">申通专线</el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">
              <i class="el-icon-user-solid" style="color: #fff"></i>
            </template>
            <el-menu-item index="11">积分充值</el-menu-item>
            <el-menu-item index="5">我的积分</el-menu-item>
            <el-menu-item index="6">邮局订单</el-menu-item>
            <el-menu-item index="7">申通订单</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="right">
        <el-menu
          :default-active="index"
          mode="horizontal"
          class="meun"
          @select="select"
          background-color="#00457d"
          text-color="#fff"
          active-text-color="#f10043"
        >
          <el-menu-item index="8">境内24小时</el-menu-item>
          <el-menu-item index="10">批量下单</el-menu-item>
          <el-menu-item index="9">我的订单</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  data() {
    return {
      index: '8',
      nav: [
        '/',
        '/user/daili',
        '/user/daili_test',
        '/query',
        '/user/st',
        '/user/jifen',
        '/user/order',
        '/user/st_order',
        '#/',
        '#/order',
        '#/excel',
        '/user/chongzhi'
      ]
    }
  },
  methods: {
    select(index) {
      // 导航列表
      if(this.nav[index]) {
        const url = this.nav[index]

        // 判断外链还是本地
        if(url.startsWith('#')) {
          this.index = index
          this.$router.push(url.slice(1))
        } else {
          location.href = url
        }
      }
    }
  },
}
</script>